import React, { useEffect, useState } from "react";
import Options from "../options";
import { Col, Row } from "react-bootstrap";
import TimeAgo from "react-timeago";
import Collapse from "../../../animation/collapse";
import { Link } from "src/types/link";
import CopyLink from "../copyLink";
import Truncate from "src/components/truncate";
import Button from "src/components/button";
import { useDispatch } from "react-redux";
import {
  deleteLinkRequest,
  invalidateAllUpdations,
} from "src/redux/actions/link";
import { useSelector } from "react-redux";

import _ from "lodash";
import cx from "classnames";
import styles from "./links.module.scss";
interface LinkProps {
  link: Link;
  activeID: string;
  setActiveID: (id: string) => void;
  deleteToggled: boolean;
  setDeleToggled: (deleteToggled: boolean) => void;
  isLast: boolean;
}

const Links: React.FC<LinkProps> = ({
  link,
  setActiveID,
  activeID,
  deleteToggled,
  setDeleToggled,
  isLast,
}) => {
  const dispatch = useDispatch();
  
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [linkUpdated, setLinkUpdated] = useState<boolean>(false);
  const [toAnimate, setToAnimate] = useState<boolean>(true);
  const [deleteLink, setDeleteLink] = useState<boolean>(false);

  const deletion = useSelector((state: any) =>
    _.get(state.link.deletion, `${link.id}`),
  );

  useEffect(() => {
    if (linkUpdated) {
      setTimeout(() => {
        setLinkUpdated(false);
        setToAnimate(false);
      }, 2000);
    }
  }, [linkUpdated]);

  useEffect(() => {
    if (!showOptions) {
      setToAnimate(true);
    }
  }, [showOptions]);

  const getTitle = () => {
    switch (link.type) {
      case "personalised":
        return link.contact.firstName;
      case "anonymous":
        return "Anonymous";
      case "campaign":
        return _.get(link.utmCampaign, "name");
    }
  };
  const getSubtitle = () => {
    switch (link.type) {
      case "personalised":
        return (
          <div className={styles.subTitleRow}>
            <span>{link.contact.email}</span>

            <div className={styles.verticalBorder}></div>
            <Truncate width={70}>
              <TimeAgo date={link.createdDate} live={false}></TimeAgo>
            </Truncate>
          </div>
        );
      case "anonymous":
      case "campaign":
        return (
          <Col xl={12}>
            <TimeAgo date={link.createdDate} live={false} />
          </Col>
          
        );
    }
  };

  const isExpired = () => {
    if (link.expiryDate) {
      const expiryTimestamp = new Date(link.expiryDate).getTime();
      return expiryTimestamp <= new Date().getTime();
    }
    return false;
  };

  return (
    <div
      className={cx(
        styles.links,{
        [styles.hideAllLinks]: !(!activeID || activeID === link.id || deleteToggled),
        [styles.disableLinks]: deleteToggled && link.id !== activeID,
        [styles.hideBorderForLinks]: showOptions
      })}
    >
      <Row className={styles.container}>
        <Col xl={8} sm={8} xs={8}>
          <Row>
            <Col xl={12} sm={12} xs={12} className={styles.title}>
              <span>{getTitle()}</span>
              {link.expiryDate && isExpired() && (
                <span className={styles.expired}>
                  Expired
                </span>
              )}
            </Col>
          </Row>
          <Row>
            <Col xl={12} sm={12} xs={12} className={styles.subTitle}>
              <Row>{getSubtitle()}</Row>
            </Col>
          </Row>
        </Col>
        <Col
          xl={4}
          sm={4}
          xs={4}
          className={cx(styles.iconContainer, {
            [styles.disableAnimations]: showOptions,
            [styles.hideIcons]: deleteLink,
          })}
        >
          <CopyLink link={link}></CopyLink>
          <div className={styles.verticalBorder}></div>

          <i
            className={cx("paperflite-settings-wheel", {
              [styles.hideIcons]: showOptions,
            })}
            onClick={() => {
              // dispatch(invalidateAllLinks());
              setShowOptions((prev) => !prev);
              setActiveID(link.id);
            }}
          ></i>

          <div
            className={cx(styles.verticalBorder, {
              [styles.hideIcons]: showOptions,
            })}
          ></div>

          <i
            onClick={() => {
              setDeleteLink(true);
              setDeleToggled(true);
              setActiveID(link.id);
              if (showOptions) {
                setShowOptions(false);
              }
            }}
            className={cx("paperflite-delete", {
              [styles.fadeLeft]: showOptions,
            })}
          ></i>
        </Col>
      </Row>

      <Collapse isOpen={deleteLink}>
        <div className={styles.deleteContainer}>
          <span className={styles.title}>
            Are you sure you want to delete this link?
          </span>
          <div className={styles.subTitle}>
            Once deleted, recipients won&apos;t be able to access the asset
            through this link anymore.
          </div>
          <div className={styles.deleteButtons}>
            <Button
              variant="primary"
              className={styles.button}
              text={
                _.get(deletion, "deleting", false) ? "Deleting..." : "Delete"
              }
              icon="paperflite-delete"
              onClick={() => {
                dispatch(
                  deleteLinkRequest({
                    id: link.id,
                  }),
                );
                setActiveID("");
                setDeleToggled(false);
              }}
            />
            <Button
              variant="secondary"
              text="Cancel"
              className={styles.button}
              onClick={() => {
                setActiveID("");
                setDeleteLink(false);
                setDeleToggled(false);
              }}
            />
          </div>
        </div>
      </Collapse>
      <Collapse isOpen={showOptions}>
        <Collapse isOpen={linkUpdated && toAnimate}>
          <span className={styles.linkUpdated}>
            Your link has been updated!
          </span>
        </Collapse>
        <Options
          onClose={() => {
            dispatch(
              invalidateAllUpdations({
                id: link.id,
              }),
            );
            setActiveID("");
            setShowOptions((prev) => !prev);
          }}
          link={link}
          className={styles.options}
          setLinkUpdated={setLinkUpdated}
        />
      </Collapse>
    </div>
  );
};

export default Links;
